.root {
  --grid-columns: none;
  --grid-rows: none;
  --grid-gap: 0;
  --grid-column-gap: var(--grid-gap);
  --grid-row-gap: var(--grid-gap);
  --grid-align: stretch;
  --grid-justify: stretch;
  --grid-padding: 0;

  display: grid;
  grid-template-columns: var(--grid-columns);
  grid-template-rows: var(--grid-rows);
  column-gap: var(--grid-column-gap);
  row-gap: var(--grid-row-gap);
  align-items: var(--grid-align);
  justify-content: var(--grid-justify);
  padding: var(--grid-padding);
}
